import { HTTPClient } from '@abaco/web-common/src/HTTP';
import axios, { CancelTokenSource } from "axios";
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { Combination, CombinationOut, CombinationUpdateOut } from '../models/Combination';

export default class CombinationApi {

    private http: HTTPClient;
    private rootPath: string;
    private cancelTokenSource: CancelTokenSource | null;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
        this.cancelTokenSource = null;
    }

    public async getCombinations(pk_cuaa: number, paging: PagingParams, filter: string | null): Promise<PagedResults<Combination>>{
        // if (this.cancelTokenSource) {
        //     this.cancelTokenSource.cancel();
        // }
        //this.cancelTokenSource = axios.CancelToken.source();
        const filterArr = [];
        if (filter) {
            filterArr.push(`^description like ${filter.toUpperCase()}`);
        }
        const res = await this.http.get(`${this.rootPath}/v1/equipments/subjects/${pk_cuaa}/combinations?preview=true`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filterArr.length > 0 ? filterArr : undefined,
            },
            cancelToken: this.cancelTokenSource?.token
        })

        return res.data;
    }

    public async getCombination(pkCuaa: number, elId: number): Promise<Combination> {
        const res = await this.http.get(`${this.rootPath}/v1/equipments/subjects/${pkCuaa}/combinations/${elId}`);
        return res.data;
    }
    public async editCombination(pkCuaa: number, elId: number, detailOut: CombinationUpdateOut): Promise<Combination> {
        const res = await this.http.put(`${this.rootPath}/v1/equipments/subjects/${pkCuaa}/combinations/${elId}`, detailOut);
        return res.data;
    }
    public async insertCombination(pkCuaa: number, detailOut: CombinationOut): Promise<Combination> {
        const res = await this.http.post(`${this.rootPath}/v1/equipments/subjects/${pkCuaa}/combinations`, detailOut);
        return res.data;
    }
    public async deleteCombination(pkCuaa: number, elId: number): Promise<Combination> {
        const res = await this.http.delete(`${this.rootPath}/v1/equipments/subjects/${pkCuaa}/combinations/${elId}`);
        return res.data;
    }

}
